import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FaSearch, FaTimes } from 'react-icons/fa';     
import { useLocation } from "react-router-dom";
import { getApiHeader } from 'utlis/commonfunctions';
import banner from "assets/images/international_esim_banner.png";
import { Backdrop, CircularProgress } from "@mui/material";
import PlanDetailsCard from "../PlanDetailsCard";

const SERVER_URL = process.env.REACT_APP_API_URL;

const RegionPlanList = () => {
    const location = useLocation();
   
    const [region , setRegion ] = useState({})

    const [selectedRegion, setSelectedRegion] = useState(null);
    const [isLoadingRegionPlanList, setIsLoadingRegionPlanList] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPlanSlug, setSelectedPlanSlug] = useState('');
    const [selectedRegionDetail, setSelectedRegionDetail] = useState(null);
    const [selectedRegionTheme, setSelectedRegionTheme] = useState("");
    const [error, setError] = useState(null);
    const [is_telsim_plan, setIsTelsimPlan] = useState(false)
    const [selectedRegionPlanList, setSelectedRegionPlanList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [retailerType , setRetailerType] = useState("PID");


    const cardStyles = {
        background: `linear-gradient(to top, ${selectedRegionTheme.top || '#D6060D'} 0%, ${selectedRegionTheme.bottom || '#000'} 100%)`,
        color: 'white'
    };
    const cardTopStyles = {
        background: `transparent`,
        color: 'white',
        fontWeight: '500',
        textTransform: 'uppercase'
    };

    const buttonStyle = {
        background: `${selectedRegionTheme.button}`,
        color: 'white',
        border: '2px solid #ccc',
        Cursor: 'pointer'
    }

    const fetchRegionPlanList = async (region_slug) => {
        setSelectedRegion(region_slug);
        setIsLoadingRegionPlanList(true);

        let res = '';
        try {
            await new Promise(resolve => setTimeout(resolve, 2000));

            const headers = await getApiHeader();
            res = await axios.get(`${SERVER_URL}international-esim/plans/${region_slug}`, {
                headers: headers
            });

            if (res.status === 200) {
                const planData = res.data.data;
 
                if (planData && planData.plans) {
                    setSelectedRegionPlanList(planData.plans);
                } else {
                    console.error('Unexpected response structure:', res.data);
                    return;
                }
                const data =  planData.country_region_data
                const themeData =  data.theme_class
                setRetailerType(res.data.data.retailer_type)
                if (data) {
                    const themeClass = JSON.parse(themeData);
                    setSelectedRegionTheme(themeClass);

                    selectedRegionDetail(data);
                    console.log("selectedRegionDetail------>",selectedRegionDetail);
                    

                } else {
                    console.error('Country information is missing in the response:', res.data);
                }
            } else {
                console.error('Error: Unexpected status code', res.status);
            }
        } catch (error) {

            console.error('Error fetching country plan list:', error.status);

            setError(400);

        } finally {
            setIsLoadingRegionPlanList(false);
        }
    };

    const handleCardClick = (plan) => {
        setSelectedPlanSlug(plan.plan_slug);
        // navigate("/international_esim/plan_details", { state: { planSlug: plan.plan_slug, plan }, replace: true });
        setShowModal(true);

    };


    const handleCloseModal = () => {
        // navigate(-1);
        setShowModal(false);
    };


    useEffect(() => {
        if (location.state?.region) {
            setRegion(location.state.region); 
    
            
        } else {
            console.warn('No region provided in location.state');
            
        }
    }, [location.state]);
    
    useEffect(() => {
        if (region?.region_slug) {
            console.log("region--------->", region);
            fetchRegionPlanList(region.region_slug); 
        }
    }, [region]);

    
    return(
        <DashboardLayout>
            <DashboardNavbar />
            <div className='container-fluid'>
            {/* <BannerSection country={country}  cardStyles={cardStyles}/> */}
            <br></br>
                <Container>
                    <Row className="mt-4">
                        {selectedRegion ? (
                            <>
                                {isLoadingRegionPlanList ? (
                                    <Backdrop
                                        open={true}
                                        style={{
                                            color: '#fff',
                                            zIndex: 9999,
                                        }}
                                    >
                                        <CircularProgress color="inherit" />
                                    </Backdrop>
                                ) : (
                                    <>
                                        {selectedRegionPlanList.length > 0 ? (
                                            selectedRegionPlanList.map((plan, index) => (
                                                <Col xs={12} sm={12} md={6} lg={4} className="mb-4 mt-1" key={index}>
                                                    <div className="card global-plan-card" style={cardStyles}>
                                                        <div
                                                            className="card-header d-flex justify-content-between align-items-center px-2"
                                                            translate="no"
                                                            style={cardTopStyles}
                                                        >
                                                            {plan.common_plan_name}
                                                            <img src={plan.plan_image} alt={plan.img_alt} title={plan.img_title} />
                                                        </div>
                                                        <div className="card-body" style={cardStyles}>
                                                            <b>
                                                                <i className="fas fa-globe"></i>&nbsp; Coverage{' '}
                                                                <span translate="no">
                                                                    { plan.plan_coverage }
                                                                </span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-arrow-up"></i>&nbsp; Data{' '}
                                                                <span>{plan.plan_data ?? ''} GB</span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-calendar-alt"></i>&nbsp; Validity{' '}
                                                                <span>
                                                                    {plan.plan_validity
                                                                        ? `${plan.plan_validity} ${plan.plan_validity === 1 ? 'Day' : 'Days'}`
                                                                        : ''}
                                                                </span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-tag"></i>&nbsp; Price{' '}
                                                                <span> AU ${plan.rtap_amount ?? ''} </span>
                                                            </b>
                                                            <hr />
                                                           
                                                            <button
                                                                className="btn btn-custom btn-block value-btn"
                                                                style={buttonStyle}
                                                                onClick={() => handleCardClick(plan)}
                                                            >
                                                              AU $ {retailerType === "PAR" ? (plan.prosegur_amount ?? '') : plan.plan_amount} - Buy Now
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            <p>No plans available</p>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <p>Select a country to view plans.</p>
                        )}
                    </Row>

                </Container>
                
            </div>
            {showModal && (
                <PlanDetailsCard show={showModal} is_telsim_plan={is_telsim_plan ? 1 : 0} button={selectedRegionTheme.button} top={selectedRegionTheme.top} bottom={selectedRegionTheme.bottom} countrySlug={region.region_slug} planSlug={selectedPlanSlug} retailerType={retailerType} handleClose={handleCloseModal} />
            )}
        </DashboardLayout> 
    )

}

export default RegionPlanList